// key: nombre del icono en el componente
// value: nombre del file en la carpeta sources
const listIcon = {
  ahora_30: 'ahora30',
  alert_edit: 'alert-edit',
  alert_edit_v2: 'alert-edit-v2',
  alert_icon_new_mobile: 'alert-edit-v2',
  alert_new: 'alert-new',
  alert_new_v2: 'alert-edit-v2',
  arrow: 'arrow',
  badge: 'badge',
  big_brands: 'big-brands',
  black_friday: 'black-friday',
  black_friday_icon: 'black-friday',
  blue_check: 'blue-check',
  bookmark: 'bookmark',
  calendar: 'calendar',
  carrot: 'carrot',
  cart_volume_discount: 'cart-volume-discount',
  cart_icon: 'cart-volume-discount',
  cbt_international: 'international-cbt',
  cbt_international_desktop: 'international-cbt',
  cbt_international_mobile: 'international-cbt',
  chevron: 'chevron',
  chevron_right: 'icon-chevron-right',
  close: 'close',
  cockade: 'cockade',
  coupon: 'icon-coupons',
  cpg: 'cpg-more',
  delivery: 'delivery',
  'destaque-compatible-icon': 'elipse-check-icon',
  elipse_check: 'elipse-check-icon',
  error_screen: 'error-screen',
  eshop: 'eshop',
  filter_toolbar: 'toolbar-filter',
  fulfillment: 'full',
  free: 'shipping-truck',
  full_icon: 'full',
  full_super: 'full-super',
  full_super_mlb: 'full-super-mlb',
  full_super_small: 'full-super',
  full_super_small_mlb: 'full-super-mlb',
  gallery_desktop: 'gallery.desktop',
  gallery_toolbar: 'toolbar-gallery',
  gift: 'gift',
  good_financing: 'good_financing',
  help_headset: 'help-headset',
  hot_sale: 'hot-sale',
  icon_pharma: 'pharma',
  ic_gift: 'ic-gift',
  ic_ahora30: 'ahora30',
  ic_hot_sale: 'hot-sale',
  info_16: 'icon-info-16',
  installation: 'installation-base',
  installation_base: 'installation-base',
  installations_icon: 'installation-base',
  international_cbt: 'international-cbt',
  international_filter_cbt: 'international-cbt',
  international_filter_mobile: 'international-cbt',
  international_logo: 'international-logo',
  international_cbt_no_world: 'international-cbt-no-world',
  is_highlight_brand_premium: 'premium-brands',
  is_highlight_brand: 'big-brands',
  like: 'like',
  list_desktop: 'list.desktop',
  list_mobile: 'list.desktop',
  list_toolbar: 'list.desktop',
  loader_error: 'map-loader-error',
  loyalty: 'loyalty',
  nextday: 'sameday_truck',
  map: 'map',
  market: 'market',
  melichoice_logo: 'melichoice',
  melichoice_icon: 'melichoice',
  melicoin: 'icon-melicoin',
  melicoin_icon: 'icon-melicoin',
  meli: 'meli',
  meli_icon: 'meli',
  meliplus: 'meli_plus_poly',
  meliplus_poly: 'meli_plus_poly',
  meli_plus_icon: 'meli_plus_poly',
  mshops_logo: 'mshops-logo',
  mosaic_toolbar: 'toolbar-mosaic',
  my_account: 'my-account',
  not_found: 'not-found',
  offer: 'offer',
  online_visit_request: 'online-visit-request',
  online_visit_icon: 'online-visit-request',
  order_toolbar: 'toolbar-order',
  pills_warning: 'pills_warning',
  play: 'play',
  premium_brands: 'premium-brands',
  price_per_quantity: 'price-per-quantity',
  question: 'question',
  question_mark: 'question-mark',
  'question-mark': 'question-mark',
  recos_full: 'full',
  rest: 'rest',
  return_purchase: 'return-purchase',
  sameday: 'sameday_truck',
  sameday_truck: 'sameday_truck',
  sameday_turbo: 'sameday_truck',
  search: 'search-light',
  search_bookmark_created_icon: 'search-bookmark-created',
  search_bookmark_created_icon_mobile: 'search-bookmark-created',
  search_bookmark_icon: 'search-bookmark',
  search_bookmark_icon_mobile: 'search-bookmark',
  search_light: 'search-light',
  search_toolbar: 'search-light',
  shipping_truck: 'shipping-truck',
  star: 'circled_star',
  star_empty: 'star-empty',
  star_full: 'star-full',
  star_half: 'star-half',
  sum: 'sum',
  supermarket: 'supermarket-fs',
  supermarket_logo: 'supermarket-fs',
  supermarket_logo_full: 'supermarket-fs',
  trade: 'trade',
  virtual_tour: 'virtual-tour',
  virtual_tour_icon: 'virtual-tour',
  warning_icon: 'warning',
  weekdeals: 'weekdeals',
  zoom_in: 'map-zoom-in',
  zoom_out: 'map-zoom-out',
  ic_navigation_coupons_ilustrated: 'ilustrated-coupons',
  ic_navigation_help_headset_ilustrated: 'ilustrated-help',
  ic_navigation_myaccount_ilustrated: 'ilustrated-my-account',
  ic_navigation_password_ilustrated: 'ilustrated-password',
  ic_navigation_purchases_ilustrated: 'ilustrated-purchases',
  ic_navigation_return_purchase_ilustrated: 'ilustrated-return-purchase',
  ic_navigation_weekdeals_ilustrated: 'ilustrated-weekdeals',
  issues_invoice: 'issues-invoice',
  f1_carv2: 'f1-car',
  f1_car_turbov2: 'f1-car-turbo',
  f1_alpine: 'f1-alpine',
  f1_alpine_turbo: 'f1-alpine-turbo',
  'recommendations-mshops_logo': 'full',
  'recommendations-cpg_icon': 'cpg-more',
  'recommendations-meli_coins': 'icon-melicoin',
  'recommendations-meli_logo': 'meli',
  'recommendations-chevron': 'chevron',
  'recommendations-black-friday_icon': 'black-friday',
  'recommendations-heart-empty': 'bookmark',
  'recommendations-heart-full': 'bookmark',
  'recommendations-full_icon': 'full',
  color: 'icon-color',
  green_check: 'green-check',
  payment: 'payment',
  icon_odr: 'icon-odr',
};

const listIconColor = {
  color_2450308: {
    type: 'solid',
    color: '#FFF',
    stroke: '#DEDEDE',
  },
  color_2450295: {
    type: 'solid',
    color: '#000',
    style: { mixBlendMode: 'hard-light' },
  },
  color_2450278: {
    type: 'palette',
    colors: ['#0288D1', '#D1FAFF', '#4FC3F7'],
  },
  color_2450281: {
    type: 'palette',
    colors: ['#D2B48C', '#F1EBE4', '#E8DCC2'],
  },
  color_2450291: {
    type: 'palette',
    colors: ['#6E4B25', '#D0C3BA', '#A67C52'],
  },
  color_2450293: {
    type: 'palette',
    colors: ['#343F9E', '#D1D9FF', '#314EF3'],
  },
  color_2450294: {
    type: 'palette',
    colors: ['#757575', '#DBDBDB', '#BDBDBD'],
  },
  color_2450296: {
    type: 'palette',
    colors: ['#E3B300', '#FFF79B', '#FFDD00'],
  },
  color_2450307: {
    type: 'palette',
    colors: ['#B71C1C', '#FFCDD2', '#E53935'],
  },
  color_2450311: {
    type: 'palette',
    colors: ['#6A1B9A', '#E1BEE7', '#B34CC5'],
  },
  color_2450312: {
    type: 'palette',
    colors: ['#DD3A82', '#F8BBD0', '#FB8CB1'],
  },
  color_2450314: {
    type: 'palette',
    colors: ['#388E3C', '#D0F0C0', '#4CAF50'],
  },
  color_2450327: {
    type: 'palette',
    colors: ['#EF6C00', '#FFE0B2', '#FF9800'],
  },
  color_2450303: {
    type: 'silver',
  },
  color_2450289: {
    type: 'golden',
  },
  color_46671867: {
    type: 'multicolor',
  },
};

export { listIcon, listIconColor };
